"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServicesForThisUserCollaborator = exports.checkIfUserEmailVerified = exports.checkIfOwner = exports.checkIfManager = exports.checkIfDirector = exports.checkIfCollaborator = exports.checkIfBusiness = exports.checkIfAdmin = void 0;
var _core = require("@guryou/core");
var _ = require(".");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var checkIfBusiness = exports.checkIfBusiness = function checkIfBusiness() {
  return (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.admin || (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.owner || (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.director || (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.manager;
};
var checkIfAdmin = exports.checkIfAdmin = function checkIfAdmin() {
  return (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.admin;
};
var checkIfOwner = exports.checkIfOwner = function checkIfOwner() {
  return (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.owner;
};
var checkIfManager = exports.checkIfManager = function checkIfManager() {
  return (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.manager;
};
var checkIfDirector = exports.checkIfDirector = function checkIfDirector() {
  return (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.director;
};
var checkIfCollaborator = exports.checkIfCollaborator = function checkIfCollaborator() {
  return (_.authService === null || _.authService === void 0 ? void 0 : _.authService.userRole) === _core.UserTypes.collaborator;
};
var checkIfUserEmailVerified = exports.checkIfUserEmailVerified = function checkIfUserEmailVerified() {
  var _authService$user;
  return _.authService === null || _.authService === void 0 || (_authService$user = _.authService.user) === null || _authService$user === void 0 ? void 0 : _authService$user.verifiedEmail;
};
var getServicesForThisUserCollaborator = exports.getServicesForThisUserCollaborator = function getServicesForThisUserCollaborator(services) {
  var _authService$user2;
  var userId = +(_.authService === null || _.authService === void 0 || (_authService$user2 = _.authService.user) === null || _authService$user2 === void 0 ? void 0 : _authService$user2.userId);
  var data = [];
  var _iterator = _createForOfIteratorHelper(services),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _s$resources;
      var s = _step.value;
      var ids = s === null || s === void 0 || (_s$resources = s.resources) === null || _s$resources === void 0 ? void 0 : _s$resources.map(function (x) {
        return +x.userId;
      });
      if (ids.includes(userId)) {
        data.push(s);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return data;
};
